// @flow

export const
  clientId: string           = process.env.CLIENT_ID || '',
  authRedirectUrl: string    = process.env.AUTH_REDIRECT_URL || '',
  authServerUrl: string      = process.env.AUTH_SERVER_URL || '',
  logoutServerUrl: string    = process.env.LOGOUT_SERVER_URL || '',
  logoutServerPath: string   = process.env.LOGOUT_SERVER_PATH || '',
  salesUrl: string           = process.env.SALES_URL || '',
  relativePath: string       = process.env.RELATIVE_PATH || '',
  talendoBaseUrl: string     = process.env.TALENDO_BASE_URL || '',
  magazineUrl: string        = process.env.MAGAZINE_URL || '',
  apiServerUrl: string       = process.env.API_SERVER_URL || '',
  googleMapsApiKey: string   = process.env.GOOGLE_MAPS_API_KEY || '',
  crawlerUrl: string         = process.env.CRAWLER_BASE_URL || '',
  lazyJobUrl: string         = process.env.LAZY_JOB_BASE_URL || '',
  advertBaseUrl: string      = process.env.ADVERT_BASE_URL || '',
  emailsPreviewUrl: string   = process.env.TALENDO_EMAILS_PREVIEW_URL || '',
  airbrakeProductId: string  = process.env.AIRBRAKE_PRODUCT_ID || '',
  airbrakeProductKey: string = process.env.AIRBRAKE_PRODUCT_KEY || '',
  joinOauthApplicationId: string = process.env.JOIN_OAUTH_APPLICATION_ID || '',
  naRegionId: string = process.env.NA_REGION_ID || '';
